<template>
  <v-footer color="#1C2F67" class="footer white--text">
    <div class="container">
      <v-row class="footer-logotypes pt-9">
        <v-col cols="auto">
          <a href="https://www.predistribuce.cz/cs/" target="_blank">
            PREdistribuce
          </a>
        </v-col>

        <v-col cols="auto">
          <a href="https://www.prezakaznicka.cz/cs/" target="_blank">
            PREzákaznická
          </a>
        </v-col>
      </v-row>

      <v-row justify="space-between" align="center" class="footer-bottom">
        <v-col cols="12">
          <div class="footer-bottom__line"></div>
        </v-col>

        <v-col cols="auto">
          &copy; {{ new Date().getFullYear() }} PREdistribuce
        </v-col>

        <v-col cols="auto">
          <ul class="footer-bottom__links row">
            <li class="col-auto">
              <a href="https://www.pre.cz/cs/zapati/technicka-pomoc/" target="_blank">
                Technická pomoc
              </a>
            </li>
            <li class="col-auto">
              <a href="https://www.predistribuce.cz/cs/zapati/ochrana-osobnich-udaju-a-internetovych-stranek/" target="_blank">
                Ochrana osobních údajů a internetových stránek
              </a>
            </li>
          </ul>
        </v-col>
      </v-row>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss">
@import '../scss/utilities/px-to-rem';

.v-application {
  .footer-logotypes a {
    @include rem(font-size, 28px);
    font-weight: 300;
    color: rgba(255, 255, 255, 0.35);
    text-decoration: none;

    &:hover {
      color: #fff;
    }
  }

  .footer-bottom {
    color: rgba(255, 255, 255, 0.5);
  }

  .footer-bottom a {
    color: #fff;

    &:hover {
      text-decoration: none;
    }
  }

  .footer-bottom__line {
    height: 1px;
    background: rgba(255, 255, 255, 0.35);
  }

  .footer-bottom__links {
    list-style: none;
  }
}
</style>
